import { postBiz, json, rows } from '../core/coreapi';

export const findExecutiveReviews = async (f:any) =>
  rows(await postBiz({s: 'bieexecutivereview', a:'find',
    pci:f.planningcycleid ?? null,
    sti:f.stateid ?? null,
    sts:f.status ?? 1,
    pgo:f.page ?? 0,
    pgl:f.pagesize ?? 50,
  }));

export const createExecutiveReview = async (p:any) =>
  json(await postBiz({s: 'bieexecutivereview', a:'create',
    pci:p.planningcycleid,
    nam:p.name,
    dsc:p.description ?? '',
    mdt:p.meetingdate ?? null,
  }));

export const recommendScenario = async (p:any) =>
  json(await postBiz({s: 'bieexecutivereview', a:'recommend',
    rid:p.reviewid,
    scc:p.scenariocode,
    fbi:p.forecastbatchid ?? null,
    cmt:p.comment ?? '',
  }));

export const returnReview = async (rid:number, reason='') =>
  json(await postBiz({s: 'bieexecutivereview', a:'return',rid,rsn:reason}));
